import './modal.css';
import { useState } from 'react';
import { useFormik } from 'formik';
import { DateRangePicker } from 'rsuite';
import { dateFormat } from '../../../utils';
import { FaRegTimesCircle } from 'react-icons/fa';
import useMasters from '../../../hooks/userMasters';
import { Backdrop, Box, Fade, MenuItem, Modal, Select, TextField, Typography } from '@mui/material';
import useGlobal from "../../../hooks/useGlobal";
import { constants } from '../../../utils/constants';

const MODAL_INPUT_SIZE = 'small';



const AppointmentFilterModal = ({
    open,
    handleClose,
    setQuery,
    refreshData
}) => {

    const { tKey: [tKey] } = useGlobal();

    const {
        services,
        gender
    } = useMasters();

    const formikIntialValues = {
        appointmentId: '',
        patientName: '',
        gender: '',
        age: '',
    }

    const formik = useFormik({
        initialValues: formikIntialValues,
        onSubmit: async data => {
            const [from, to] = calenderValue;
            const _data = {
                ...data,
                page: 1,
                slotDateFrom: from && dateFormat(from),
                slotDateTo: to && dateFormat(to)
            }
            setQuery(_data)
            refreshData(_data)
            handleClose()
        }
    });


    const [calenderValue, setCalenderValue] = useState([null, null])


    return (
        <>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <Box sx={style}>
                        <form onSubmit={formik.handleSubmit}>
                            <div className="query-pop-up">
                                <h4> Filter Appointments </h4>
                                <span onClick={handleClose}>
                                    <FaRegTimesCircle
                                        style={{
                                            width: "2rem",
                                            height: "1.5rem"
                                        }}
                                    />
                                </span>
                            </div>

                            {/* Content */}
                            <Typography id="transition-modal-description" className='query-para' >
                                <div className='query-body'>
                                    <div className="query-details">
                                        <p>Appointment ID</p>
                                        <TextField
                                            type={'text'}
                                            value={formik.values.appointmentId}
                                            className="width-full"
                                            size='small'
                                            name='appointmentId'
                                            onChange={formik.handleChange}
                                        />
                                    </div>

                                    <div className="query-details">
                                        <p>Appointment Date</p>
                                        <DateRangePicker
                                            ranges={[]}
                                            className="width-full text-capitalize"
                                            showOneCalendar // to show only one calender
                                            value={calenderValue}
                                            onChange={newValue => setCalenderValue(newValue || [null, null])}
                                            name="valid"
                                            format="dd-MM-yyyy"
                                            placeholder="Select Date Range"
                                            placement='auto'
                                        />
                                    </div>

                                    <div className="query-details">
                                        <p>Speciality Choosen</p>
                                        <Select
                                            className="width-full text-capitalize"
                                            size={MODAL_INPUT_SIZE}
                                            name='serviceId'
                                            onChange={formik.handleChange}
                                            value={formik.values.serviceId}
                                        >
                                            <MenuItem
                                                className='text-capitalize'
                                                key={null}
                                                value={null}
                                            >
                                                ---select---
                                            </MenuItem>
                                            {
                                                services.length > 0
                                                    ? services.map(key => {
                                                        return (
                                                            <MenuItem
                                                                className='text-capitalize'
                                                                key={key?.serviceId}
                                                                value={key?.serviceId}
                                                            >

                                                                {key?.service_master?.name?.[tKey] ?? constants.DOTS} - {key.UI}
                                                            </MenuItem>
                                                        );
                                                    })
                                                    : <NoItemFound />
                                            }
                                        </Select>
                                    </div>

                                    <div className="query-details">
                                        <p>Patient Name</p>
                                        <TextField
                                            type={'text'}
                                            className="width-full"
                                            size='small'
                                            name='patientName'
                                            onChange={formik.handleChange}
                                            value={formik.values.patientName}
                                        />
                                    </div>

                                    <div className="query-details">
                                        <p>Patient Name</p>
                                        <TextField
                                            type={'text'}
                                            className="width-full"
                                            size='small'
                                            name='patientName'
                                            onChange={formik.handleChange}
                                            value={formik.values.patientName}
                                        />
                                    </div>

                                    <div className="query-details">
                                        <p>Gender</p>
                                        <Select
                                            className="width-full text-capitalize"
                                            size={MODAL_INPUT_SIZE}
                                            name='gender'
                                            onChange={formik.handleChange}
                                            value={formik.values.gender}
                                        >
                                            <MenuItem
                                                className='text-capitalize'
                                                key={null}
                                                value={null}
                                            >
                                                ---select---
                                            </MenuItem>
                                            {
                                                Object.keys(gender).length > 0
                                                    ? Object.keys(gender).map(key => {
                                                        return (
                                                            <MenuItem
                                                                className='text-capitalize'
                                                                key={key}
                                                                value={key}
                                                            >
                                                                {gender[key]}
                                                            </MenuItem>
                                                        );
                                                    })
                                                    : <NoItemFound />
                                            }
                                        </Select>
                                    </div>
                                    <div className="query-details">
                                        <p>Age</p>
                                        <TextField
                                            type={'number'}
                                            className="width-full"
                                            size='small'
                                            name='age'
                                            onChange={formik.handleChange}
                                            value={formik.values.age}
                                        />
                                    </div>
                                </div>
                            </Typography>

                            {/*  */}
                            <div className="query-btn-content">
                                <div className="query-mark-btn">
                                    <button
                                        className='mark-query text-white'
                                        style={{
                                            backgroundColor: 'var(--steel-blue)',
                                            color: 'white'
                                        }}
                                        type='submit'
                                    >
                                        Filter
                                    </button>

                                    <div
                                        className='mark-query text-white'
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </div>
                                </div>
                            </div>
                        </form>
                    </Box>
                </Fade>
            </Modal>
        </>
    )
}

function NoItemFound() {
    return <MenuItem>No Items</MenuItem>
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    // height:450,
    borderRadius: "1rem",
    bgcolor: 'white',

    // boxShadow: 24,
    // paddingTop:"1rem"
};


export default AppointmentFilterModal